<template>
  <v-autocomplete
    :items="this.inputData.Items"
    v-model="this.inputData.select"
    :prepend-icon="this.inputData.icon"
    :label="this.inputData.label"
    :item-text="this.inputData.item_text"
    :item-value="this.inputData.item_value"
    dense
    style="z-index: 99;"
    @change="triggermachine($event)"
  />
  <!-- this will trigger the event in newfilter via machineselect component and it will make new API call for page reload for new machine -->
</template>

<script>
export default {
  props: ["inputData"],
  data() {
    return {
      machineSelected: "",
      DropDownLabel: "select machine",
      item_text: "machine_name",
      item_value: "id",
    };
  },
  methods: {
    triggermachine(event) {
      let triggerData = { selectmachine: event, data: this.inputData };
      console.log("method call 1", triggerData);
      this.$emit("triggermachine", triggerData);
    },
  },
};
</script>
